export default __webpack_public_path__ + "static/media/team.3be4fd23.jpg";